module.exports = __webpack_public_path__ + "static/media/impressum.6991bb64.md";